import type { MouseEvent } from 'react';

/**
 * MDF-39: a Clear button unmounts once the filters are empty, so focus would drop to the page body.
 * Returns a click handler that clears, then focuses the Filter button of the same tab.
 */
export const clearThenFocusFilter =
  (clear: () => void) =>
  (event: MouseEvent<HTMLElement>): void => {
    // Find the trigger before the clear: the clicked button leaves the DOM on the next render.
    let el: HTMLElement | null = event.currentTarget;
    while (el && !el.querySelector('[data-filter-trigger]')) el = el.parentElement;
    clear();
    el?.querySelector<HTMLElement>('[data-filter-trigger]')?.focus();
  };
